/** 
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _isControlledProperty = _interopRequireDefault(require("../../utils/isControlledProperty"));
var isSelectionControlled = function isSelectionControlled(props) {
  return (0, _isControlledProperty.default)(props, 'selected');
};
var _default = isSelectionControlled;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@inovua/reactdatagrid-community/hooks/useSelection/isSelectionControlled.js
// module id = 222
// module chunks = 0